import { type FC, type SVGProps } from "react";

export const LogoGemini: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="currentColor"
		viewBox="0 0 24 24"
		{...props}
	>
		<path d="M12 0c0 3.183 1.264 6.236 3.515 8.485C17.764 10.736 20.817 12 24 12c-3.183 0-6.236 1.264-8.485 3.515C13.264 17.764 12 20.817 12 24c0-3.183-1.264-6.236-3.515-8.485C6.236 13.264 3.183 12 0 12c3.183 0 6.236-1.264 8.485-3.515C10.736 6.236 12 3.183 12 0Z" />
	</svg>
);
